import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const PhotoPopUpMessage = (props) => {
  return (
    <Dialog open onClose={() => props.setPopMessage(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Are You Sure</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You want to delete this {props.type === "photo" ? "photo" : "video"}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setPopMessage(false)}>No</Button>
        <Button variant="contained" color="error" onClick={() => props.confirmDelete(props.id)}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhotoPopUpMessage;
